var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnmuteVdoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M448.001 152.533C441.52 149.615 434.323 148.666 427.306 149.804C420.29 150.941 413.762 154.116 408.535 158.933L362.668 201.6V170.667C362.668 153.693 355.925 137.414 343.923 125.412C331.92 113.41 315.642 106.667 298.668 106.667H106.668C89.6941 106.667 73.4155 113.41 61.4131 125.412C49.4108 137.414 42.668 153.693 42.668 170.667V341.333C42.668 358.307 49.4108 374.586 61.4131 386.588C73.4155 398.591 89.6941 405.333 106.668 405.333H298.668C315.642 405.333 331.92 398.591 343.923 386.588C355.925 374.586 362.668 358.307 362.668 341.333V310.4L408.748 353.067C415.532 359.207 424.344 362.626 433.495 362.667C438.573 362.655 443.59 361.564 448.215 359.467C454.507 356.921 459.897 352.558 463.697 346.934C467.497 341.31 469.534 334.681 469.548 327.893V184.107C469.517 177.295 467.449 170.648 463.609 165.021C459.769 159.394 454.333 155.045 448.001 152.533Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmuteVdoIcon);
export default __webpack_public_path__ + "static/media/unmute_vdo_icon.9651c7dfb8e1fe7d5ffb1bca9ea18836.svg";
export { ForwardRef as ReactComponent };